import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[aspectRatioBox]',
    standalone: false
})
export class AspectRatioBoxDirective {

  @Input() ratio: any = {
    'width': null,
    'height': null
  };

  percentage:any;

  ngAfterContentChecked() {
		// this.el.nativeElement.children[0].style.width = this.percentage;
	}

  constructor(private el: ElementRef) { }

  ngOnInit(){
    this.percentage = (this.ratio.height * 100) / this.ratio.width + '%';
    this.el.nativeElement.style.paddingBottom = this.percentage;
  }
  
}
